import React from 'react';
import { Box } from '@amzn/awsui-components-core';
import { EnhancedAISummaryBox } from 'src/components/generic-components/ai-summary-components/EnhancedAISummaryBox';
import { ProcessedBusinessReportingData } from './BusinessReportingTicketDataProcessing';
import { ProcessedBusinessReportingUserData } from './BusinessReportingUserDataProcessing';
import { BusinessReportingFilters } from './BusinessReportingSelectionFilters';

interface BusinessReportingCustomPromptSummaryProps {
  title: string;
  pageType: string;
  processedTicketData?: ProcessedBusinessReportingData;
  processedUserData?: ProcessedBusinessReportingUserData;
  businessFilters: BusinessReportingFilters;
  originalFilterOptions: string;
  isLoading?: boolean;
  statusKey?: string;
  statusValue?: string;
  filters?: string;
  aggregatedData?: string;
}

export const BusinessReportingCustomPromptSummary: React.FC<BusinessReportingCustomPromptSummaryProps> = ({
  title,
  pageType,
  processedTicketData,
  processedUserData,
  businessFilters,
  originalFilterOptions,
  isLoading = false,
  statusKey = 'finished',
  statusValue = 'finished',
  filters,
  aggregatedData
}) => {
  const getDataForPageType = () => {
    if (pageType.includes('Ticket')) {
      return {
        processedTicketData,
        processedUserData,
        aggregatedDataString: aggregatedData || JSON.stringify(processedTicketData?.aggregatedData || {}),
        processedFilters: filters || processedTicketData?.processedFilters || '{}'
      };
    } else if (pageType.includes('User')) {
      return {
        processedTicketData: null,
        processedUserData,
        aggregatedDataString: aggregatedData || JSON.stringify(processedUserData?.aggregatedData || []),
        processedFilters: filters || processedUserData?.processedFilters || '{}'
      };
    }

    return {
      processedTicketData: null,
      processedUserData: null,
      aggregatedDataString: aggregatedData || '{}',
      processedFilters: filters || processedTicketData?.processedFilters || processedUserData?.processedFilters || '{}'
    };
  };

  const { processedTicketData: ticketData, processedUserData: userData, aggregatedDataString, processedFilters } = getDataForPageType();

  if (isLoading) {
    return null;
  }

  return (
    <Box margin={{ bottom: 's' }}>
      <EnhancedAISummaryBox
        title={title}
        statusKey={statusKey}
        statusValue={statusValue}
        pageType={pageType}
        filters={processedFilters}
        aggregatedData={aggregatedDataString}
        originalOptions={originalFilterOptions}
        processedTicketData={ticketData}
        processedUserData={userData}
        businessFilters={businessFilters}
      />
    </Box>
  );
};
